export default {
    id: 'UA-97311140-3',
}
